// Meta Pixel helper functions
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = (pixelId: string) => {
  // Only run in browser
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  // Check if already initialized
  if (window.fbq) return // Initialize Meta Pixel
  ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]

    // Safety check: if no script tags exist, append to head
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export const trackEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data)
  }
}

export const trackLead = (data?: any) => {
  trackEvent('Lead', data)
}
